var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-data-wrap"},[_c('div',{staticClass:"circle"},[(_vm.imgUrl)?_c('fps-img',{attrs:{"src":_vm.imgUrl}}):_vm._e()],1),_vm._l((_vm.texts),function(t,i){return _c('p',{key:i},[_vm._v(_vm._s(t))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }